import dealflowLogoTeal from "../images/dealflow.PNG";
import ppProfileLogo from "../images/pp_profile.png";
import moneyBagIcon from "../images/money bag.png";
import investmentOpportunitiesIcon from "../images/investment-opportunities.png";
import mediaOpportunitiesIcon from "../images/media-opportunities.svg";
import ropeIcon from "../images/rope.png";
import giftIcon from "../images/gift.png";
import "./DealFlowConfirmation.css";

function DealFlowConfirmation() {
  return (
    <div className="dfc-page">
      <main className="dfc-main">
        <div className="dfc-main-grid">
          <section className="dfc-left-col">
            <div className="dfc-main-brand">
              <img src={dealflowLogoTeal} alt="Dealflow" className="dfc-logo" />
            </div>

            <div className="dfc-card">
              <h1 className="dfc-title">You&apos;re in.</h1>
              <p className="dfc-copy">
                You will now receive Dealflow in your email inbox.
              </p>

              <div className="dfc-services-strip" aria-label="Dealflow opportunities">
                <div className="dfc-service-card">
                  <div className="dfc-service-icon-wrap">
                    <img src={moneyBagIcon} alt="Paid Partnerships" className="dfc-icon" />
                  </div>
                </div>
                <div className="dfc-service-card">
                  <div className="dfc-service-icon-wrap">
                    <img src={ropeIcon} alt="PR Appearances" className="dfc-icon" />
                  </div>
                </div>
                <div className="dfc-service-card">
                  <div className="dfc-service-icon-wrap">
                    <img
                      src={mediaOpportunitiesIcon}
                      alt="Media Opportunities"
                      className="dfc-icon dfc-icon-media"
                    />
                  </div>
                </div>
                <div className="dfc-service-card">
                  <div className="dfc-service-icon-wrap">
                    <img
                      src={investmentOpportunitiesIcon}
                      alt="Investment Opportunities"
                      className="dfc-icon dfc-icon-investment"
                    />
                  </div>
                </div>
                <div className="dfc-service-card">
                  <div className="dfc-service-icon-wrap">
                    <img src={giftIcon} alt="Gifting Opportunities" className="dfc-icon" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footer className="dfc-footer">
        <div className="dfc-footer-inner">
          <a href="/" className="dfc-footer-pp-link" aria-label="Back to deals">
            <img src={ppProfileLogo} alt="Players Punch" className="dfc-footer-pp" />
          </a>
          <div className="dfc-footer-left">© 2026 Player&apos;s Punch. All rights reserved.</div>
          <div className="dfc-footer-links">
            <a className="dfc-footer-contact" href="/dealflow/terms">
              Terms
            </a>
            <a className="dfc-footer-contact" href="/dealflow/privacy">
              Privacy
            </a>
            <a className="dfc-footer-contact" href="mailto:dealflow@playerspunch.com">
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default DealFlowConfirmation;
